import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import { DateRangeMobi, Box } from '@esgian/esgianui';
import { useSegment } from '@hooks';
const DateRangePicker = ({
  startDate = null,
  endDate = null,
  dateFormat = 'MMM YYYY',
  dateWheels = 'MMM YYYY',
  onClose,
  inputVariant = 'outlined',
  label = '',
  inputSize = 'medium',
  isRequired = false,
  disableFuture = true,
  InputPropsSx = {}
}) => {
  const { isRoRo } = useSegment();
  return (
    <Box>
      <DateRangeMobi
        sx={{
          inputProps: {
            autoComplete: 'off',
            fullWidth: true,
            size: inputSize,
            label: `${label}${isRequired && label !== '' ? '*' : ''}`,
            InputProps: { sx: { fontSize: '0.875rem', ...InputPropsSx } },
            variant: inputVariant,
            defaultValue: undefined,
            value:
              startDate || endDate
                ? `${startDate ? moment(startDate).format(dateFormat) : ''} - ${
                    endDate ? moment(endDate).format(dateFormat) : ''
                  }`
                : null
          }
        }}
        onClose={({ value }) => {
          let start = value[0] ?? null;
          let end = value[1] ?? null;
          if (start?.isValid()) {
            start = value[0].startOf('day');
            if (dateFormat === 'MMM YYYY') {
              start = start.startOf('month');
            }
          }
          if (end?.isValid()) {
            end = value[1].endOf('day');
            if (dateFormat === 'MMM YYYY') {
              end = end.endOf('month');
            }
            if (end.isBefore(start)) {
              end = null;
            }
          }

          if (start !== startDate || end !== endDate) {
            onClose(start, end);
          }
        }}
        dateFormat={dateFormat}
        minStartDate={isRoRo ? moment('07-2022', 'MM-YYYY') : moment('07-2023', 'MM-YYYY')}
        disableFuture={disableFuture}
        startDate={startDate}
        endDate={endDate}
        placeholder={'Period'}
        dateWheels={dateWheels}
      />
    </Box>
  );
};

DateRangePicker.propTypes = {
  disableFuture: PropTypes.bool,
  isRequired: PropTypes.bool,
  startDate: PropTypes.object,
  InputPropsSx: PropTypes.object,
  endDate: PropTypes.object,
  label: PropTypes.string,
  inputSize: PropTypes.oneOf(['small', 'medium', 'large']),
  dateFormat: PropTypes.string,
  inputVariant: PropTypes.oneOf(['standard', 'contained', 'filled']),
  onClose: PropTypes.func.isRequired,
  dateWheels: PropTypes.string
};

export default DateRangePicker;
